import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { Router } from '@angular/router';

import {
  DASHBOARD_TILES,
  type CrudEntityKey,
  type DashboardTile
} from '../../core/config/entity-config';
import { AuthService } from '../../core/services/auth.service';
import { DataStoreService } from '../../core/services/data-store.service';

@Component({
  selector: 'app-dashboard-page',
  imports: [CommonModule],
  templateUrl: './dashboard-page.component.html',
  styleUrl: './dashboard-page.component.css'
})
export class DashboardPageComponent {
  protected readonly tiles = DASHBOARD_TILES;

  constructor(
    private readonly authService: AuthService,
    private readonly dataStoreService: DataStoreService,
    private readonly router: Router
  ) {}

  openTile(tile: DashboardTile): void {
    void this.router.navigateByUrl(tile.route);
  }

  logout(): void {
    this.authService.logout();
    void this.router.navigate(['/login']);
  }

  getTileMeta(tile: DashboardTile): string {
    if (!tile.supportsCrud) {
      return 'Summary view';
    }

    return `${this.dataStoreService.getCollectionCount(tile.key as CrudEntityKey)} records`;
  }
}